import React from "react";
import "./ViewerControls.css";

const ViewerControls = ({ onFitToWindow, onResetView, onToggleFullscreen }) => {
  return (
    <div className="viewer-controls">
      <button className="control-btn" onClick={onFitToWindow}>
        📏 Fit to Window
      </button>
      <button className="control-btn" onClick={onResetView}>
        🔄 Reset View
      </button>
      <button className="control-btn" onClick={onToggleFullscreen}>
        🔍 Toggle Fullscreen
      </button>
    </div>
  );
};

export default ViewerControls;
